import { combineReducers } from "redux";
import { call, put, select, takeLatest, all } from 'redux-saga/effects';
import { reportsAPI } from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import { START } from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";



export const STAFF_INFO_REQUEST = "STAFF_INFO_REQUEST";
export const SET_FORM_DATA = "SET_STAFF_INFO_FORM_DATA";

export const staffInfoReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
});

//actions
export const staffInfoActions = createActions('staffInfo', STAFF_INFO_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload });

// SAGAS
export function* staffInfoWatcher() {
    yield takeLatest(`${STAFF_INFO_REQUEST}${START}`, staffInfoWorker)
}

const unwrap = (response) => {
    const answer = response?.data?.Answer
    // if (!answer || answer.Result !== 'Success') {
    //     const desc = answer?.Data_?.Error?.desc || 'Unknown API error'
    //     throw new Error(desc)
    // }
    const data = answer.Data_ || {}
    const rows = data.items || []
    return { academicYear: data.academicYear, rows }
}

function* staffInfoWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.staffInfo.form)
        const params = { ...auth, ...form }
        const [staffingRes, pedagogicalRes, awardsRes] = yield all([
            call(reportsAPI.staffInfoStaffing, params),
            call(reportsAPI.staffInfoPedagogical, params),
            call(reportsAPI.staffInfoAwards, params),
        ])
        const data = {
            staffing: unwrap(staffingRes),
            pedagogical: unwrap(pedagogicalRes),
            // awards: [],
            awards: unwrap(awardsRes),
        }
        yield put(staffInfoActions.staffInfoRequestSuccess(data));
    } catch (error) {
        yield put(staffInfoActions.staffInfoRequestError(error));
    }
}
